import CardPreview from "./pages/CardPreview";
import DefaultLayout from "./common/components/DefaultLayout";
import Registration from "./pages/Registration";
import ErrorPage from "./pages/Error";
import Landing from "./pages/Landing";

export const routes = [
  {
    path: "/",
    component: <Landing />,
    layout: DefaultLayout,
  },
  {
    path: "/registration",
    component: <Registration />,
    layout: DefaultLayout,
  },
  {
    path: "/card-preview",
    component: <CardPreview />,
    layout: DefaultLayout,
  },
  {
    path: "*",
    component: <ErrorPage />,
    layout: DefaultLayout,
  },
];
